module.exports = __webpack_public_path__ + "media/images/iconDown__okGreen--dark-cf17560e155bdd94a907075c1adea678.png";